import { createContext } from 'react';

interface StyleContextType {
  insertCss: (...styles: any[]) => () => void;
}

// Create a context with a no-op insertCss function
const StyleContext = createContext<StyleContextType>({
  insertCss: () => () => {},
});

export default StyleContext;
